export default "/_next/static/videos/QR-menuro-e100bfb66f8d19c5e2fd726175e909dc.mp4";